import { Box ,InputAdornment,IconButton} from "@material-ui/core"
import { navigate } from '@reach/router'
import React, { useEffect, useState } from 'react'
import { TemplateProps } from "../../journeys/journey/Interfaces"
import './bedroom.css'
import AmsTypography from "../../atoms/AmsTypography/AmsTypography"
import AmsButton from "../../atoms/AmsButton/AmsButton"
import AmsDivider from "../../atoms/AmsDivider/AmsDivider"
import AmsProductCount from "../../atoms/AmsProductCount/AmsProductCount"
import AmsProductList from "../../molecules/AmsProductList/AmsProductList"
import MessageBlock from "../../molecules/MessageBlock/MessageBlock"
import axios from "axios";
import AmsLoading from "../../atoms/AmsLoading/AmsLoading";

const inventoryApiEndPoint = process.env["REACT_APP_INVENTORY_API_END_POINT"]

const inventorey_api_key = process.env["REACT_APP_INVENTORY_API_KEY"];

const BedRoom: React.FC<TemplateProps> = (props: any) => {
  
    const { templateProps } = props
    const { title,listItems,messageBlock ,btnProps } = templateProps
    const [inventoryList,setInventoryList] = useState([]);
    const [loading,setLoading] = useState(true);
    const handleSubmit = async (event:any) => {
        navigate(btnProps?.nextScreen)
    }

    useEffect(() => {
        getCustomerDetails()
    },[])

    const getCustomerDetails =async () => {

     
        
        let response = await axios.get(`${inventoryApiEndPoint}${7059714}`,{
            headers:{
                'x-api-key': inventorey_api_key,
              
            }
        })

        let inventory = response?.data
        let listData:any = [];
        if(response){
            
            inventory?.map((item:any, index:any) => {
                let singleItem = {index:index, text:item?.item,count:item?.quantity}

                listData.push(singleItem)
            })
        }
        setInventoryList(listData)
    
        setLoading(false)
        

    }

    if(loading){
        return (
            <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            p={4}
            mt={18}
        >
            {<AmsLoading />}
        </Box>
        )
    }


    return (
        <Box className="baseContainerBlock HomeBlock">
             <Box className="title" mb={5} mt={5}> 
                <AmsTypography variant="h1" text={title} />
            </Box>
            <Box  mb={5} mt={5}>
                <AmsDivider />
            </Box>

            <Box  mb={5} mt={5} className="productsList">
            {inventoryList?.length > 0 && <AmsProductList list={inventoryList} roomType="bedRoom" />}
            </Box> 

            <Box mb={5} mt={5} className="messageBlock">
                {messageBlock && <MessageBlock />}
            </Box>

            <Box className="btnBlock">
                <AmsButton
                        attributes={btnProps?.attributes}
                        handleClick={handleSubmit}
                    />    
            </Box>
        </Box>
    )
}

export default BedRoom